<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="mt-5 pt-4 row justify-content-center">
        
        <!-- Formulario para editar productos -->
        <div v-if="view == 1" class="col-12 m-0 p-0">
          <div class="col-12 mb-3">
            <label style="color: #616161;"><strong>EDITAR PRODUCTO</strong></label><br>
          </div>
          <div class="form-group">
            <div class="row" style="text-align: left">
              <div class="col-12 m-0 p-0">
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Nombre del producto *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.product.name }"
                        type="text"
                        v-model="form.product.name"
                        class="form-control"
                        placeholder="Escribe aquí el nombre del producto"
                      />
                    </div>
                    <span
                      v-if="errors.product.name"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.product.name }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Subtitulo del producto *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.product.subTitle }"
                        type="text"
                        v-model="form.product.subTitle"
                        class="form-control"
                        placeholder="Escribe aquí el subtitulo del producto"
                      />
                    </div>
                    <span
                      v-if="errors.product.subTitle"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.product.subTitle }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Descripción del producto *</strong>
                      </label>
                      <textarea
                        :class="{ 'is-danger': errors.product.description }"
                        type="textarea"
                        v-model="form.product.description"
                        class="form-control"
                        placeholder="Escribe aquí la descripción del producto"
                      />
                    </div>
                    <span
                      v-if="errors.product.description"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.product.description }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Enlace del producto *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.product.link }"
                        type="text"
                        v-model="form.product.link"
                        class="form-control"
                        placeholder="Escribe aquí el enlace del producto"
                      />
                    </div>
                    <span
                      v-if="errors.product.link"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.product.link }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Estado del producto * </strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.product.status }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.product.status"
                      >
                        <option value="null" disabled selected
                        >Seleccione el estado del producto
                        </option>
                        <option value="1">Activo</option>
                        <option value="2">Inactivo</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.product.status"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.product.status }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <form ref="form" style="text-align: initial">
                      <label for="image" style="color: #616161; font-size: 14px">
                        <strong>Reemplazar imagen *</strong>
                      </label><br>
                      <input
                        type="file"
                        accept="image/*"
                        id="image"
                        name="image"
                        class="form-control-file mb-2"
                        style="color: black"
                        @change="selectedImgProduct($event)"
                        :class="{ 'is-danger': errors.product.image || errors.product.image }"
                        ref="imgProduct"
                      />
                      <span v-if="errors.product.image" class="text-danger small error-danger">
                        {{ errors.product.image }}
                      </span><br>
                    </form>
                    <div v-if="form.product.image" class="col-12">
                      <template>
                        <img
                          width="120"
                          class="mr-3"
                          alt="imagen del producto"
                          ref="image_product" 
                          :src="form.product.image"
                        />
                      </template>
                    </div>
                    <div class="commentary">
                      <span>
                        RECOMENDACIÓN: solo se permiten imagenes en formato (jpg, jpeg, png).
                      </span><br>
                      <span>
                        El tamaño máximo debe ser de 1MB.
                      </span><br>
                      <span>
                        El tamaño de la imagen debe ser 500 x 500 pixeles.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Formulario para editar distribuidor -->
        <div v-if="view == 2" class="col-12 m-0 p-0">
          <div class="col-12 mb-3">
            <label style="color: #616161;"><strong>EDITAR DISTRIBUIDOR</strong></label><br>
          </div>
          <div class="form-group">
            <div class="row" style="text-align: left">
              <div class="col-12 m-0 p-0">
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Nombre del distribuidor *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.distributor.name }"
                        type="text"
                        v-model="form.distributor.name"
                        class="form-control"
                        placeholder="Escribe aquí el nombre del distribuidor "
                      />
                    </div>
                    <span
                      v-if="errors.distributor.name"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.distributor.name }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Dirección *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.distributor.address }"
                        type="text"
                        v-model="form.distributor.address"
                        class="form-control"
                        placeholder="Escribe aquí la dirección del distribuidor"
                      />
                    </div>
                    <span
                      v-if="errors.distributor.address"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.distributor.address }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Número de celular *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.distributor.cellphone }"
                        type="text"
                        v-model="form.distributor.cellphone"
                        class="form-control"
                        placeholder="Escribe aquí el número de celular del distribuidor"
                      />
                    </div>
                    <span
                      v-if="errors.distributor.cellphone"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.distributor.cellphone }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Teléfono *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.distributor.phone }"
                        type="text"
                        v-model="form.distributor.phone"
                        class="form-control"
                        placeholder="Escribe aquí el número de teléfono del distribuidor"
                      />
                    </div>
                    <span
                      v-if="errors.distributor.phone"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.distributor.phone }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Enlace a la web *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.distributor.link }"
                        type="text"
                        v-model="form.distributor.link"
                        class="form-control"
                        placeholder="Escribe aquí el enlace del distribuidor"
                      />
                    </div>
                    <span
                      v-if="errors.distributor.link"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.distributor.link }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Departamento(s) del distribuidor (separados por una coma ",") *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.distributor.department }"
                        type="text"
                        v-model="form.distributor.department"
                        class="form-control"
                        placeholder="Escribe aquí el departamento del distribuidor"
                      />
                    </div>
                    <span
                      v-if="errors.distributor.department"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.distributor.department }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Estado *</strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.distributor.status }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.distributor.status"
                      >
                        <option value="null" disabled selected
                        >Seleccione el estado del distribuidor
                        </option>
                        <option value="1">Activo</option>
                        <option value="2">Inactivo</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.distributor.status"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.distributor.status }}</span
                    >
                  </div>

                  <div class="col-12 col-lg-6">
                    <form ref="form" style="text-align: initial">
                      <label for="image" style="color: #616161; font-size: 14px">
                        <strong>Reemplazar imagen de perfil del distribuidor *</strong>
                      </label><br>
                      <input
                        type="file"
                        accept="image/*"
                        id="image"
                        name="image"
                        class="form-control-file mb-2"
                        style="color: black"
                        @change="selectedImgDistributor($event)"
                        :class="{ 'is-danger': errors.distributor.image || errors.distributor.image }"
                        ref="imgDistributor"
                      />
                      <span v-if="errors.distributor.image" class="text-danger small error-danger">
                        {{ errors.distributor.image }}
                      </span><br>
                    </form>
                    <div v-if="form.distributor.image" class="col-12">
                      <template>
                        <img
                          width="120"
                          class="mr-3"
                          alt="imagen del producto"
                          ref="image_distributor"
                          :src="form.distributor.image"
                        />
                      </template>
                    </div>
                    <div class="commentary">
                      <span>
                        RECOMENDACIÓN: solo se permiten imagenes en formato (jpg, jpeg, png).
                      </span><br>
                      <span>
                        El tamaño máximo debe ser de 1MB.
                      </span><br>
                      <span>
                        El tamaño de la imagen debe ser 500 x 500 pixeles.
                      </span>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <form ref="form" style="text-align: initial">
                      <label for="image" style="color: #616161; font-size: 14px">
                        <strong>Reemplazar imagen con la información del distribuidor *</strong>
                      </label><br>
                      <input
                        type="file"
                        accept="image/*"
                        id="image"
                        name="image"
                        class="form-control-file mb-2"
                        style="color: black"
                        @change="selectedImgInfoDistributor($event)"
                        :class="{ 'is-danger': errors.distributor.image_info || errors.distributor.image_info }"
                        ref="imgInfoDistributor"
                      />
                      <span v-if="errors.distributor.image_info" class="text-danger small error-danger">
                        {{ errors.distributor.image_info }}
                      </span><br>
                    </form>
                    <div v-if="form.distributor.image_info" class="col-12">
                      <template>
                        <img
                          width="120"
                          class="mr-3"
                          alt="imagen del producto"
                          ref="image_info_distributor"
                          :src="form.distributor.image_info"
                        />
                      </template>
                    </div>
                    <div class="commentary">
                      <span>
                        RECOMENDACIÓN: solo se permiten imagenes en formato (jpg, jpeg, png).
                      </span><br>
                      <span>
                        El tamaño máximo debe ser de 1MB.
                      </span><br>
                      <span>
                        El tamaño de la imagen debe ser 375 x 530 pixeles.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="view > 0" class="col-12 mt-5 mb-3" style="text-align: center">
          <button
            @click="edit()"
            type="button"
            class="btn btn-danger btn-sm button-login"
            style="padding:5px 25px"
          >
            <template v-if="loading.changeDoc">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Editando...
            </template>
            <template v-else><strong>Editar {{ view == 1 ? "Producto" : "Distribuidor" }}</strong></template>
          </button>
        </div>
        <div class="hr-border"></div>
      </div>
    </div>
  </div>
</template>
  
<script>
// import $ from "jquery";
import axios from 'axios'

export default {
  data() {
    return {
      height_img: "",
      width_img: "",
      view: 1,
      items: [],
      productId: null,
      distributorId: null,
      form: {
        product: {
          name: "",
          subTitle: "",
          description: "",
          link: "",
          status: null,
          image: null,
        },
        distributor: {
          name: "",
          address: "",
          cellphone: "",
          phone: "",
          link: "",
          department: "",
          status: null,
          image: null,
          image_info: null,
        }
      },
      errors: {
        product: {
          name: false,
          subTitle: false,
          description: false,
          link: false,
          status: false,
          image: false,
        },
        distributor: {
          name: false,
          address: false,
          cellphone: false,
          phone: false,
          link: false,
          department: false,
          status: false,
          image: false,
          image_info: false,
        }
      },
      loading: {
        changeDoc: false,
      },
    };
  },
  methods: {
    selectedImgProduct(event) {
      let app = this;
      var fileSize = null;
      var extension = null;

      fileSize = event.target.files[0].size;
      extension = event.target.files[0].name.split(".");
      if (fileSize > 1000000) {
        app.errors.product.image = "La imagen no debe superar 1MB.";
        return false;
      }
      if ( extension[1] != "jpg" && extension[1] != "png" && extension[1] != "jpeg") {
        app.errors.product.image = "La extensión es inválida.";
        return false;
      } else {
        app.errors.product.image = false;
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function(e) {
          app.$refs.image_product.src = e.target.result;
        };
        app.form.product.image = event.target.files[0];
      }
    },
    selectedImgDistributor(event) {
      let app = this;
      var fileSize = null;
      var extension = null;

      fileSize = event.target.files[0].size;
      extension = event.target.files[0].name.split(".");
      if (fileSize > 1000000) {
        app.errors.distributor.image = "La imagen no debe superar 1MB.";
        return false;
      }
      if ( extension[1] != "jpg" && extension[1] != "png" && extension[1] != "jpeg") {
        app.errors.distributor.image = "La extensión es inválida.";
        return false;
      } else {
        app.errors.distributor.image = false;
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function(e) {
          app.$refs.image_distributor.src = e.target.result;
        };
        app.form.distributor.image = event.target.files[0];
      }
    },
    getImageSize() {
      if(this.view == 1){
        const img = new Image();
        img.src = this.$refs.image_product.src;
        img.onload = () => {
          this.width_img = img.width;
          this.height_img = img.height;
          if(this.width_img != 500){
            this.errors.product.image = "El ancho de la imagen debe ser de 500px.";
            return false;
          }
          else if(this.height_img != 500){
            this.errors.product.image = "El alto de la imagen debe ser de 500px.";
            return false;
          }
          if(!this.errors.product.image){
            return true;
          }
        };
      }
      else if(this.view == 2){
        const img = new Image();
        img.src = this.$refs.image_distributor.src;
        img.onload = () => {
          this.width_img = img.width;
          this.height_img = img.height;
          if(this.width_img != 500){
            this.errors.distributor.image = "El ancho de la imagen debe ser de 500px.";
            return false;
          }
          else if(this.height_img != 500){
            this.errors.distributor.image = "El alto de la imagen debe ser de 500px.";
            return false;
          }
          if(!this.errors.distributor.image){
            return true;
          }
        };
      }
    },
    selectedImgInfoDistributor(event) {
      let app = this;
      var fileSize = null;
      var extension = null;

      fileSize = event.target.files[0].size;
      extension = event.target.files[0].name.split(".");
      if (fileSize > 1000000) {
        app.errors.distributor.image_info = "La imagen no debe superar 1MB.";
        return false;
      }
      if ( extension[1] != "jpg" && extension[1] != "png" && extension[1] != "jpeg") {
        app.errors.distributor.image_info = "La extensión es inválida.";
        return false;
      } else {
        app.errors.distributor.image_info = false;
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function(e) {
          app.$refs.image_info_distributor.src = e.target.result;
        };
        app.form.distributor.image_info = event.target.files[0];
      }
    },
    getImageInfoSize() {
      const img = new Image();
      img.src = this.$refs.image_info_distributor.src;
      img.onload = () => {
        this.width_img = img.width;
        this.height_img = img.height;
        if(this.width_img != 375){
          this.errors.distributor.image_info = "El ancho de la imagen debe ser de 375px.";
          return false;
        }
        else if(this.height_img != 530){
          this.errors.distributor.image_info = "El alto de la imagen debe ser de 530px.";
          return false;
        }
        if(!this.errors.distributor.image_info){
          return true;
        }
      };
    },
    validForm() {
      let app = this;
      
      if(app.view == 1){
        if (!app.form.product.name) {
          app.errors.product.name = "El nombre es requerido.";
          return false;
        }
        if (!app.form.product.subTitle) {
          app.errors.product.subTitle = "El subtitulo es requerido.";
          return false;
        }
        if (!app.form.product.description) {
          app.errors.product.description = "La descripción es requerida.";
          return false;
        }
        if (!app.form.product.link) {
          app.errors.product.link = "El enlace es requerido.";
          return false;
        }
        if (!app.form.product.status) {
          app.errors.product.status = "El estado es requerido.";
          return false;
        }
        if (!app.form.product.image) {
          app.errors.product.image = "La imagen es requerida";
          return false;
        }
        if (
          !app.errors.product.name &&
          !app.errors.product.subTitle &&
          !app.errors.product.description &&
          !app.errors.product.link &&
          !app.errors.product.status &&
          !app.errors.product.image
        ) {
          return true;
        }
        return false;
      }

      else if(app.view == 2){
        if (!app.form.distributor.name) {
          app.errors.distributor.name = "El nombre es requerido.";
          return false;
        }
        if (!app.form.distributor.address) {
          app.errors.distributor.address = "La dirección es requerida.";
          return false;
        }
        if (!app.form.distributor.cellphone) {
          app.errors.distributor.cellphone = "El número de celular es requerido.";
          return false;
        }
        if (!app.form.distributor.phone) {
          app.errors.distributor.phone = "El número de teléfono es requerido.";
          return false;
        }
        if (!app.form.distributor.link) {
          app.errors.distributor.link = "El enlace es requerido.";
          return false;
        }
        if (!app.form.distributor.department) {
          app.errors.distributor.department = "El departamento es requerido.";
          return false;
        }
        if (!app.form.distributor.status) {
          app.errors.distributor.status = "El estado es requerido.";
          return false;
        }
        if (!app.form.distributor.image) {
          app.errors.distributor.image = "La imagen es requerida";
          return false;
        }
        if (!app.form.distributor.image_info) {
          app.errors.distributor.image_info = "La imagen informativa es requerida";
          return false;
        }

        if (
          !app.errors.distributor.name &&
          !app.errors.distributor.address &&
          !app.errors.distributor.cellphone &&
          !app.errors.distributor.phone &&
          !app.errors.distributor.link &&
          !app.errors.distributor.department &&
          !app.errors.distributor.status &&
          !app.errors.distributor.image &&
          !app.errors.distributor.image_info
        ) {
          return true;
        }
        return false;
      }
    },
    edit() {
      let app = this;
      if(app.view == 1){
        if (app.validForm()) {
          app.editProduct();
        }
      }
      else if(app.view == 2){
        if (app.validForm()) {
          app.editDistributor();
        }
      }
    },
    editProduct() {
      const formData = new FormData();
      formData.append("id", this.productId);
      formData.append("name", this.form.product.name);
      formData.append("sub_title", this.form.product.subTitle);
      formData.append("description", this.form.product.description);
      formData.append("link", this.form.product.link);
      formData.append("status_id", this.form.product.status);
      formData.append("image", this.form.product.image);

      this.loading.changeDoc = true;
      axios
        .post("superAdmin/edit/product", formData)
        .then((res) => {
          // console.log('res: ', JSON.stringify(res));
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.loading.changeDoc = false;
            this.$router.push({ name: "listProducts" });
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    editDistributor() {
      const formData = new FormData();
      formData.append("id", this.distributorId);
      formData.append("name", this.form.distributor.name);
      formData.append("address", this.form.distributor.address);
      formData.append("cellphone", this.form.distributor.cellphone);
      formData.append("phone", this.form.distributor.phone);
      formData.append("link", this.form.distributor.link);
      formData.append("department", this.form.distributor.department);
      formData.append("status_id", this.form.distributor.status);
      formData.append("image", this.form.distributor.image);
      formData.append("image_info", this.form.distributor.image_info);

      this.loading.changeDoc = true;
      axios
        .post("superAdmin/edit/distributor", formData)
        .then((res) => {
          // console.log('res: ', JSON.stringify(res));
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.loading.changeDoc = false;
            this.$router.push({ name: "listProducts" });
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getProducts(){
      this.items = [];
      this.loading.history = true;

      axios
      .get("superAdmin/get/products")
      .then(res => {
        if (res.data.cod == 0) {
          this.items = res.data.data;
          this.items.forEach(element => {
            if(element.id == this.productId){
              this.form.product.name = element.name;
              this.form.product.subTitle = element.sub_title;
              this.form.product.description = element.description;
              this.form.product.link = element.link;
              this.form.product.status = element.status_id;
              this.form.product.image = element.image;
            }
          });
        }
        this.loading.history = false;
      })
      .catch(error => {
        this.loading.history = false;
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    getDistributors(){
      this.items = [];
      this.loading.history = true;

      axios
      .get("superAdmin/get/sectionWeb/distributors")
      .then(res => {
        if (res.data.cod == 0) {
          this.items = res.data.data;
          this.items.forEach(element => {
            if(element.id == this.distributorId){
              this.form.distributor.name = element.name;
              this.form.distributor.address = element.address;
              this.form.distributor.cellphone = element.cellphone;
              this.form.distributor.phone = element.phone;
              this.form.distributor.link = element.link;
              this.form.distributor.department = element.department;
              this.form.distributor.status = element.status_id;
              this.form.distributor.image = element.image;
              this.form.distributor.image_info = element.image_info;
            }
          });
        }
        this.loading.history = false;
      })
      .catch(error => {
        this.loading.history = false;
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
  },
  mounted() {
    this.productId = this.$route.params.productId;
    this.distributorId = this.$route.params.distributorId;
    this.view = this.$route.params.view;
    this.getProducts();
    this.getDistributors();
  },
  watch: {
    // Producto
    "form.product.name": function(newV) {
      if (!newV) {
        this.errors.product.name = "El nombre es requerido.";
      } else {
        this.errors.product.name = false;
      }
    },
    "form.product.subTitle": function(newV) {
      if (!newV) {
        this.errors.product.subTitle = "El subtitulo es requerido.";
      } else {
        this.errors.product.subTitle = false;
      }
    },
    "form.product.description": function(newV) {
      if (!newV) {
        this.errors.product.description = "La descripción es requerida.";
      } else {
        this.errors.product.description = false;
      }
    },
    "form.product.link": function(newV) {
      if (!newV) {
        this.errors.product.link = "El enlace es requerido.";
      } else {
        this.errors.product.link = false;
      }
    },
    "form.product.status": function(newV) {
      if (!newV) {
        this.errors.product.status = "El estado es requerido.";
      } else {
        this.errors.product.status = false;
      }
    },
    "form.product.image": function(newV) {
      if (!newV) {
        this.errors.product.image = "La imagen es requerida.";
      } else {
        this.errors.product.image = false;
      }
    },

    // Distribuidor
    "form.distributor.name": function(newV) {
      if (!newV) {
        this.errors.distributor.name = "El nombre es requerido.";
      } else {
        this.errors.distributor.name = false;
      }
    },
    "form.distributor.address": function(newV) {
      if (!newV) {
        this.errors.distributor.address = "El subtitulo es requerido.";
      } else {
        this.errors.distributor.address = false;
      }
    },
    "form.distributor.cellphone": function(newV) {
      if (!newV) {
        this.errors.distributor.cellphone = "La descripción es requerida.";
      } else {
        this.errors.distributor.cellphone = false;
      }
    },
    "form.distributor.phone": function(newV) {
      if (!newV) {
        this.errors.distributor.phone = "El enlace es requerido.";
      } else {
        this.errors.distributor.phone = false;
      }
    },
    "form.distributor.link": function(newV) {
      if (!newV) {
        this.errors.distributor.link = "El enlace es requerido.";
      } else {
        this.errors.distributor.link = false;
      }
    },
    "form.distributor.department": function(newV) {
      if (!newV) {
        this.errors.distributor.department = "El departamento es requerido.";
      } else {
        this.errors.distributor.department = false;
      }
    },
    "form.distributor.status": function(newV) {
      if (!newV) {
        this.errors.distributor.status = "El estado es requerido.";
      } else {
        this.errors.distributor.status = false;
      }
    },
    "form.distributor.image": function(newV) {
      if (!newV) {
        this.errors.distributor.image = "La imagen es requerida.";
      } else {
        this.errors.distributor.image = false;
      }
    },
    "form.distributor.image_info": function(newV) {
      if (!newV) {
        this.errors.distributor.image_info = "La imagen informativa es requerida.";
      } else {
        this.errors.distributor.image_info = false;
      }
    },
  },
};
</script>
    
<style>
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
   padding-right: 0px !important;
   padding-left: 0px !important;
   overflow: hidden;
  }
  
  .hr-border {
   border-top: 1px solid rgb(198 198 198);
   height: 15px;
   width: 100%;
   background-color: white;
  }
  
  .div-button {
   margin-top: 50px;
   text-align: left;
  }
  
  .is-danger {
   border: solid 2px !important;
   border-color: #e9434c !important;
  }
  
  .modal-title {
   color: black;
   font-weight: bold;
  }
  
  .modal-question {
   border: solid 3px;
   border-color: #dc3545;
   border-radius: 15px;
  }
  
  label {
   color: black;
   margin-right: 4px;
  }
  
  .img-banner {
   display: block;
   width: 25%;
   text-align: center;
   margin: auto;
  }
  
  td {
   text-align: center;
   vertical-align: -webkit-baseline-middle;
   cursor: all-scroll;
  }
  
  .table-container {
   overflow: auto;
  }
  
  h5 {
   margin-bottom: 10px !important;
  }
  
  .commentary {
   text-align: left;
   color: #1da5df;
   font-size: 13px;
  }
  
  .page-item.active .page-link {
   border-style: none;
   border-radius: 20px;
   background-color: #dc3545;
  }
  
  a.page-link {
   color: black;
   cursor: pointer;
  }
  
  a.page-link:hover {
   color: #dc3545;
  }
  
  .page-link {
   background-color: #f5f5dc00;
   border-radius: 20px;
   border-color: none;
  }
  
  .page-item.disabled .page-link {
   color: #dc3545;
   background-color: #fff0;
   border-color: #dee2e600;
  }
  
  .ul-pagination {
   padding: 0px;
  }
  
  .multiselect__tag {
   background-color: #dc3545 !important;
  }
  .multiselect__tag-icon:after {
   color: #ffffff;
   font-size: 18px;
  }
  .multiselect__tag-icon:hover {
   color: #ffffff;
   font-size: 18px;
   background-color: #b80012;
  }
  
  .multiselect__option--highlight {
   background: #17a2b8;
   outline: none;
   color: #fff;
  }
  .alert-danger {
   border-color: red !important;
  }
</style>